<template>
	<div class="letter-recievers-groups">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a :href=route_list>Группы получателей</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Редактировать группу получателей</li>
            </ol>
        </nav>

		<div class="letter-recievers-groups__recievers">
			<div class="mb-4">
				<label class="input-label">Название группы</label>
				<input v-model="group_name" id="recieverEmail" type="text" class="form-control input-field">
			</div>
		</div>

		<div class="letter-recievers-groups__recievers">
            <div style="position: relative;" class="mb-4 input-field">
                <label class="form-label">Email адреса</label>
                <input v-model="receiversEmails"
                       @keypress.enter="validateEmails"
                       type="text"
                       :class="emailError ? 'form-control input-error' : 'form-control'"
                       placeholder="Разделить через пробел"
                >
                <p class="text-error" v-if="emailError">{{ emailError }}</p>
            </div>

            <svg @click="validateEmails" class="email-add-btn" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L11 14L15 10M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z" stroke="#0678F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
		</div>

		<div v-if="emails.length" class="letter-recievers-groups__selected-recievers mb-4">
			<div class="selected-reciever"
				v-for="(item, index) in emails">
					{{ item.email ? item.email : item}}
					<svg @click="removeEmail(index, item)" class="selected-reciever__button" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_641_26163)">
							<path d="M12 4L4 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M4 4L12 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
						</g>
						<defs>
							<clipPath id="clip0_641_26163">
								<rect width="16" height="16" fill="white"/>
							</clipPath>
						</defs>
					</svg>
			</div>
		</div>

		<div class="letter-recievers-groups__control-buttons">
            <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="save"/>
			<a :href=route_list id="cancelButton" class="btn btn-lg btn-outline-dark me-3">Отменить</a>
		</div>

        <Alert />
	</div>
</template>

<script>

import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';
import Receivers from '../../../../models/Mailings/Receivers';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
	name: 'RecieversGroupEditComponent',
    components: { Alert, ConfirmBtn },
    props: {
        route_list: String,
        route_get: String,
        route_edit_group: String,
        route_get_list_emails: String,
        route_update_list_emails: String,
        group_id: [String, Number]
    },
	data: function () {
        return {
            receivers: new Receivers({
                route_get: this.route_get
            }),
            group_name: null,
			emails: [],
            receiversEmails: '',
            emailError: '',
            removeEmails: [],
            removeEmailsIds: [],
            oldEmails: [],
            newEmails: [],
		};
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        getGroup: async function () {
            let item = await this.receivers.get(this.group_id);
            this.group_name = item.name;
        },
        getEmails: async function () {
            let data = await axios.get(this.route_get_list_emails, {
                params: {
                    group_id: this.group_id
                }
            });
            this.emails = data.data.items;
        },
        validateEmails() {
            if (!this.receiversEmails) return;
            const emailPattern = /^(?!.*\.\.)[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
            const emails = this.receiversEmails.trim().split(/\s+/);
            let invalidEmails = [];

            emails.forEach(email => {
                if (emailPattern.test(email) && this.emails.findIndex(el => el.email === email) === -1 && !this.newEmails.includes(email)) {
                    this.emails.push(email);
                    this.newEmails.push(email);
                    
                    const removedIndex = this.removeEmails.findIndex(item => item.email === email);
                    if (removedIndex !== -1) {
                        this.removeEmails.splice(removedIndex, 1);
                        this.removeEmailsIds.splice(removedIndex, 1);
                    }

                } else {
                    invalidEmails.push(email);
                    this.emailError = 'Проверьте, что адреса соответствуют формату (a@a.ru), разделены пробелом, не содержат кириллицы и запрещённых символов ( , : ! и т.п), а также не повторяются.';
                }
            });
            this.receiversEmails = invalidEmails.join(' ');
            if (!this.receiversEmails) this.emailError = '';
        },
        removeEmail: async function (index, email) {
            let newEmailsIndex = this.newEmails.findIndex(el => el == email);
            if (newEmailsIndex >= 0) this.newEmails.splice(newEmailsIndex, 1);
            this.emails.splice(index, 1);

            if (email.id) {
                this.removeEmails.push(email);
                this.removeEmailsIds.push(email.id);
            }
        },
        save: async function () {
            this.validateEmails();

            if (!this.emails.length && !this.emailError) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Добавьте хотя бы одного получателя' });
                this.toggleLoading();
                return;
            }

            if (this.emailError) return;

            let updateGroup = await axios.post(this.route_edit_group,
                {
                    name: this.group_name,
                    group_id: this.group_id
                }
            );

            let updateEmails = await axios.post(this.route_update_list_emails,
                {
                    emails: this.emails,
                    group_id: this.group_id,
                    remove_emails_ids: this.removeEmailsIds,
                    new_emails: this.newEmails.join(' ')
                    // new_emails: this.emails.filter(item => !this.oldEmails.includes(item)).join(' ')
                }
            );
            if (updateEmails.data.status == 'ok' && updateGroup.data.status == 'ok') {
                window.location.href = this.route_list;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: updateEmails.data.message ? updateEmails.data.message : updateGroup.data.message });
                this.toggleLoading();
            }
        },
    },
    watch: {
        receiversEmails: {
            handler(newValue) {
                if (newValue === '') this.emailError = '';
            }
        }
    },
    mounted () {
        this.getGroup();
        this.getEmails();
    }
}

</script>

<style scoped lang="scss">
.text-error {
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    color: #E33535;
}

.input-error {
    border: 1px solid #E33535;
}

.letter-recievers-groups {
    &__recievers {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 60px;
    }
    &__selected-recievers {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;
    }
}

.email-add-btn {
    align-self: center;
    margin-left: -46px;
    cursor: pointer;
}
.input-label {
    font-size: 14px;
    font-weight: 600;
}
.page-label {
    font-size: 18px;
    font-weight: 600;
}
.input-field {
    width: 400px;
    &__date {
        width: 300px;
    }
}
.selected-reciever {
    border: 1px solid #EAEEF4;
    border-radius: 5px;
    padding: 5px 8px;
    &__button {
        cursor: pointer;
    }
    &__button:hover {
        path {
            stroke: red;
            transition: stroke 0.15s ease;
        }
    }
}
</style>